// Product page: the rating beside the price scrolls to this product's Loox reviews section
// (templates/product.json section 1789996690228b7fcd). Shopify prefixes section ids with the template id.
document.addEventListener('click', (event) => {
  const badge = event.target.closest('.product-info .rating-badge');
  if (!badge) return;
  const reviews = document.getElementById('shopify-product-reviews') || document.querySelector('[id$="__1789996690228b7fcd"]');
  if (!reviews) return;
  event.preventDefault();
  reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Logo list ("As seen in") on phones: page dots and auto-advance for the swipeable row set up in custom.css.
// Two logos per page; advances every 3s, loops, pauses for 6s after a touch, and stays still for reduced motion.
document.querySelectorAll('.shopify-section--logo-list .logo-list').forEach((list) => {
  const phone = window.matchMedia('(max-width: 699px)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const pages = () => Math.max(1, Math.ceil(list.scrollWidth / list.clientWidth - 0.01));
  const current = () => Math.round(list.scrollLeft / list.clientWidth);
  const dots = document.createElement('div');
  dots.className = 'page-dots logo-list-dots';
  let resumeAt = 0;

  const render = () => {
    dots.innerHTML = '';
    for (let i = 0; i < pages(); i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'relative';
      dot.setAttribute('aria-label', `Page ${i + 1}`);
      dot.setAttribute('aria-current', String(i === current()));
      dot.addEventListener('click', () => { resumeAt = Date.now() + 6000; goTo(i); });
      dots.appendChild(dot);
    }
  };
  const goTo = (i) => list.scrollTo({ left: i * list.clientWidth, behavior: still.matches ? 'auto' : 'smooth' });
  const mark = () => [...dots.children].forEach((d, i) => d.setAttribute('aria-current', String(i === current())));

  list.after(dots);
  render();
  list.addEventListener('scroll', mark, { passive: true });
  list.addEventListener('touchstart', () => { resumeAt = Date.now() + 6000; }, { passive: true });
  window.addEventListener('resize', render);
  setInterval(() => {
    if (!phone.matches || still.matches || document.hidden || Date.now() < resumeAt) return;
    goTo((current() + 1) % pages());
  }, 3000);
});

// Product copy: section labels. The descriptions and the Shipping accordion mark a section with a paragraph that is
// only bold text (<p><strong>AT A GLANCE</strong></p>), and custom.css styles those as labels. CSS can't tell such a
// paragraph from one with a bold phrase inside a sentence ("Our <strong>Signature Bow Keyring</strong> is..."),
// because selectors don't see text nodes, so this adds .is-subheading only where the bold text is all the paragraph
// holds. It runs again on anything the theme or the theme editor inserts later. Without it the labels stay bold text.
(() => {
  const scope = ':is(.product-info, .product-content-below-gallery) .prose > p';

  const mark = (root) => {
    const paragraphs = root.matches?.(scope) ? [root] : root.querySelectorAll?.(scope) ?? [];

    paragraphs.forEach((p) => {
      const children = [...p.children].filter((child) => !child.matches('meta, br'));
      let bold = children.length === 1 ? children[0] : null;

      if (bold?.matches('span') && bold.children.length === 1) bold = bold.firstElementChild;

      const text = p.textContent.trim();
      p.classList.toggle('is-subheading', Boolean(bold?.matches('strong, b')) && text !== '' && text === bold.textContent.trim());
    });
  };

  mark(document);

  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach((node) => node.nodeType === 1 && mark(node)));
  }).observe(document.body, { childList: true, subtree: true });
})();

// Product cards: quick add states (snippets/product-card.liquid). The add itself is Prestige's product form (theme.js
// ProductForm: /cart/add.js, then variant:add and cart:change, which refresh and open the cart drawer). This adds the
// card's states around it: "Adding…" while the request runs (ProductForm also disables the button), "Added" for 2s,
// then the label again; or the error line under the button. Each state goes to the card's aria-live region. A submit
// while the request or the "Added" state is running is dropped, so a quick double tap adds one bag. ProductForm leaves
// the button disabled when the request itself fails (offline, no JSON back), so after 15s without an answer the card
// shows the error and frees the button.
(() => {
  const FORM = 'form.product-card__quick-add';
  const strings = window.themeVariables?.strings ?? {};
  const locked = new WeakMap(); // form -> timer, for as long as the form takes no new submit

  const partsOf = (form) => ({
    actions: form.closest('.product-card__actions'),
    button: form.querySelector('button[type="submit"]'),
    error: form.querySelector('.product-card__quick-add-error'),
    status: form.querySelector('[data-quick-add-status]')
  });

  const fail = (form) => {
    const { actions, button, error, status } = partsOf(form);

    clearTimeout(locked.get(form));
    locked.delete(form);
    button.removeAttribute('disabled');
    button.removeAttribute('aria-busy');
    button.textContent = button.dataset.label;
    error.hidden = false;
    status.textContent = error.textContent.trim();
    delete actions.dataset.state;

    // Disabling the button can drop focus to the page; give it back so keyboard users see the error and can retry
    if (!document.activeElement || document.activeElement === document.body) {
      button.focus({ preventScroll: true });
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches(FORM)) return;

    if (locked.has(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    const { actions, button, error, status } = partsOf(form);

    if (!button.dataset.label) button.dataset.label = button.textContent.trim();
    button.textContent = strings.cardQuickAddAdding;
    status.textContent = strings.cardQuickAddAdding;
    error.hidden = true;
    actions.dataset.state = 'adding';
    locked.set(form, setTimeout(() => fail(form), 15000));
  }, true);

  document.addEventListener('variant:add', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.matches(FORM)) return;

    const { actions, button, error, status } = partsOf(form);

    clearTimeout(locked.get(form));
    error.hidden = true;
    button.textContent = strings.cardQuickAddAdded;
    status.textContent = strings.cardQuickAddAdded;
    actions.dataset.state = 'added';
    locked.set(form, setTimeout(() => {
      locked.delete(form);
      button.textContent = button.dataset.label;
      status.textContent = '';
      delete actions.dataset.state;
    }, 2000));
  });

  document.addEventListener('cart:error', (event) => {
    const form = event.target;

    if (form instanceof HTMLFormElement && form.matches(FORM)) fail(form);
  });
})();
